export default __webpack_public_path__ + "static/media/Link.357545f2.svg";